<template>
    <div>
        <div class="assets-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">我的资产</span>
                <span class="deadline-text">截至日期 {{ date }}</span>
            </div>
            <div style="display: flex; align-items: center">
                <el-select v-model="sourceflag" placeholder="选择购买渠道" class="select-class">
                    <el-option
                        v-for="item in sourceflags"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
                <div class="assets-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称"
                        class="input-search"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="suffix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchAssets"
                        />
                    </el-autocomplete>
                </div>
            </div>
        </div>
        <div class="assets-info">
            <div v-for="(item, index) in amountTypes" :key="index" class="assets-item">
                <div class="amount-type">
                    {{ item.text }}
                </div>
                <div v-if="index == 0" class="assets-text">
                    {{ $util.fmtNum(item.val) }}
                </div>
                <div v-else class="assets-text" :class="$util.colorClass($util.fmtNum(item.val))">
                    {{ $util.fmtNum(item.val) }}
                </div>
            </div>
        </div>
        <div class="asset-type">
            <div
                v-for="(item, index) in assetsTypes"
                :key="index"
                :class="selectIndex == index ? 'type-select' : 'type-normal'"
                v-on:click="selectType(index)"
            >
                {{ item }}
            </div>
        </div>
        <el-row v-if="assets.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>暂无数据</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                    </div>
                    <div style="color: #999999">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="销售机构" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.distributorname ? scope.row.distributorname : "" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持仓市值(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    <div>昨日收益</div>
                    <div>(元)</div>
                </template>
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.lastprofit))">
                        {{ $util.fmtNum(scope.row.lastprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    <div>持仓收益</div>
                    <div>(元)</div>
                </template>
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.currentprofit))">
                        {{ $util.fmtNum(scope.row.currentprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="160">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-tooltip
                            v-if="scope.row.isBuy"
                            class="item"
                            effect="info"
                            :content="scope.row.isBuy + '，不能申购'"
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">申购</el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{ scope.row.status == "1" ? "认购" : "申购" }}
                        </el-button>
                        <div class="line"></div>
                        <el-tooltip
                            v-if="scope.row.isSell"
                            class="item"
                            effect="info"
                            :content="scope.row.isSell"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">赎回</el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            赎回
                        </el-button>
                        <div class="line"></div>
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "MyAssets",
    components: {},
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            amountTypes: [
                {
                    text: "资产总计(元)",
                    val: ""
                },
                {
                    text: "最新收益(元)",
                    val: ""
                },
                {
                    text: "累计收益(元)",
                    val: ""
                }
            ], // 金额类型
            assetsTypes: [
                "全部",
                // '大成钱柜',
                "基金资产"
            ],
            sourceflag: null, // 购买渠道
            sourceflags: [
                {
                    label: "全部购买渠道",
                    value: ""
                },
                {
                    label: "直销",
                    value: "1"
                },
                {
                    label: "代销",
                    value: "2"
                }
            ], // 购买渠道列表
            selectIndex: 0, // 选中资产类型下标
            curPage: 1, // 当前页
            date: "", // 当前日期
            hasLoad: false // 是否已经查询数据
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchAssets();
            }
        },
        sourceflag(val, from) {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.doAction();
    },
    methods: {
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toCompPage("/main/fund/productdetail/index.shtml", {
                product_code: val.fundcode
            });
        },
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets(val, cb);
            }, 500);
        },
        // 获取资产信息
        async getAssets(val, cb) {
            if (!this.$cache.getBinded()) {
                return;
            }
            // const _x = {
            //     keyword: val ? val : (this.searchText ? this.searchText : ""),
            //     pagesize: cb ? 20 : this.pagecount,
            //     pagenum: val ? 1 : this.pageoffset,
            // };
            const res = await fundApi.getAssetsList({
                producttype: "@",
                sourceflag: this.sourceflag ? this.sourceflag : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pageSize: cb ? 20 : this.pagecount,
                pageNum: val ? 1 : this.pageoffset
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                const array = res.data.returnList ? res.data.returnList : [];
                this.amountTypes[0].val = this.allAssets.totalasset;
                this.amountTypes[1].val = this.allAssets.lastprofit;
                this.amountTypes[2].val = this.allAssets.totalprofit;
                array.forEach((fund, index) => {
                    fund.isBuy = this.$util.checkBuy(fund.status);
                    fund.isSell = this.$util.checkSell(fund);
                    fund.isChange = this.$util.checkChange(fund);
                    fund.isCurrency = this.$util.checkGeneral(fund);
                });
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.assets = array;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, array);
                }
            }
        },
        // 搜索资产
        searchAssets() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 切换资产类型
        selectType(index) {
            if (this.selectIndex != index) {
                this.selectIndex = index;
                this.pageoffset = 1;
                this.doAction();
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        // 跳转到详情
        showDetail(item) {
            sessionStorage.setItem("_currentAsset", JSON.stringify(item));
            this.$router.push("/assetsDetail");
        },
        // 点击申购或赎回按钮
        callbackFn(way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "24") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            if (way === "24") {
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                this.$router.push({ name: "sellfund", query: { fundcode: fund.fundcode } });
            } else {
                let _url = "";
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    _url = "buyfund";
                                    sessionStorage.setItem(_url, JSON.stringify(_x));
                                    _this.$router.push({
                                        name: _url,
                                        query: { fundcode: _x.fundcode }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 15px 0;
    .deadline-text {
        font-size: 14px;
        color: #999999;
        line-height: 25px;
    }
    .select-class {
        font-size: 14px;
        padding: 5px 15px;
        vertical-align: middle;
    }
    .assets-search {
        padding: 5px 0;
        .input-search {
            width: 350px;
            vertical-align: middle;
            .search-icon {
                margin: 3px 5px;
                color: #666666;
            }
            .el-input__inner {
                height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: $color-a;
                color: $text-color6;
                font-size: $f20;
                border-color: $color-a;
                padding: 0 10px;
            }
        }
    }
}
.assets-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: solid 1px #f1f1f1;

    .assets-item {
        width: 30%;
        height: 110px;
        border-radius: 6px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        padding-top: 20px;
        padding-left: 32px;

        .amount-type {
            font-size: 14px;
            color: #333333;
            margin-bottom: 10px;
        }
        .assets-text {
            font-size: 32px;
            font-weight: 500;
            color: #000000;
        }
        .add {
            color: $risk5;
        }
        .reduce {
            color: $risk1;
        }
    }
}

.asset-type {
    display: flex;
    padding: 16px 0px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;

    .type-normal {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: #f5f5f5;
        color: #666666;
        margin-right: 30px;
        cursor: pointer;
    }
    .type-select {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: #e20014;
        color: #ffffff;
        margin-right: 30px;
        cursor: pointer;
    }
}
.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}
.line {
    background: #e8e8e8;
    width: 1px;
    height: 12px;
}
.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
    &.add {
        color: $risk5;
    }
    &.reduce {
        color: $risk1;
    }
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 20px;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}
.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: #e60012;
}
.el-button--text.is-disabled {
    color: #cccccc;
}
.page-box {
    padding: 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
